import React, { Component } from "react";
import ReactDOM from "react-dom";
import { constants, KeolisSpinner } from './common/commonExport';
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
  getWorkdayAction,
  onCertifyAction,
  editWorkday,
  deleteWorkday,
  addWorkday,
  hideModalAction,
  showModalAction, setDefaultWorkdayAction, toggleWorkdayAction, editAllActivityAction,
  actErrorAction, submitWorkdayAction, resetWorkdayAction, changesInActivityAction,
  tabChangeAction,
  onCertifyHOSLogAction,
  changeWorkdayActivityLogs
} from "../actions/index";
import Activities from "./activities";
import CommentsModal from "./comments-modal";
import ActivityModalComp from '../components/activity-modal';
import ScrollArea from "react-scrollbar";
import moment from "moment";
import EandDActivies from '../containers/e-and-d-activities';

class ActivityModal extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      count: 0,
      defaultWorkday: {},
      toggleState: false,
      key: 1,
      isEdit: false,
      isResetWorkday:false
      
    };
  }

  oncloseErrPop() {

    if (this.props.activityErr) {
      this.props.onActErr(false, true);  // para1: errpop, para2: acterr
    } else {
      this.props.onActErr(false, false);  // para1: errpop, para2: acterr
    }
  }


    renderCertifyModal(defaultWorkday) {

    var addingWorkday = false;
    var workdays = this.props.workdays;
    var workday = this.props.workday, count = this.state.count;
    if (defaultWorkday && Object.keys(defaultWorkday).length > 0) {
      workday = Object.assign({}, JSON.parse(JSON.stringify(defaultWorkday)));
    }
    if (workday && Object.keys(workday).length > 0) {
      if (count == 0) {
        var defaultWorkday = JSON.parse(JSON.stringify(workday));
        this.props.setDefaultWorkday(defaultWorkday);
        this.setState({
          count: count + 1
        });
      }

      if (
        this.props.showModal == true &&
        (this.props.modalName == constants.hosModals.Certify_Modal ||
          this.props.modalName == constants.hosModals.Comments_Modal)
      ) {

        return (
          <Activities validWorkday={this.chkWorkdayValidity()} showEditActivityButton={this.showEditActivityButton()}
            defaultWorkday={workday} addingWorkday={addingWorkday} eventKey={this.state.key} isEdit={this.state.isEdit} isLogUser = {this.props.isLogUser} islogAdmin ={this.props.islogAdmin}
            calculatePreviousDutyTime ={ this.calculatePreviousDutyTime.bind(this)} oncloseErrPop={() => this.oncloseErrPop.bind(this)}
            isResetWorkday={this.state.isResetWorkday}
            />);
      }
    }
    else if (localStorage.getItem('route') == constants.FRA_REPORT && !this.props.isLoading && this.props.fraworkdays != undefined) {

      let fraworkdays =  this.props.fraworkdays;     

      let activities = [];
     if(Object.keys(this.props.fraworkdays).length > 0)
    {   
    fraworkdays.map((workday, index) => {
        activities.push(
          <Activities 
            key={index}
            validWorkday={this.chkWorkdayValidity()} 
            showEditActivityButton={this.showEditActivityButton()}
            defaultWorkday={workday} 
            addingWorkday={addingWorkday} 
            eventKey={this.state.key} 
            isEdit={this.state.isEdit} 
            isLogUser = {this.props.isLogUser} 
            isFRAReport={localStorage.getItem('route') == constants.FRA_REPORT}
                islogAdmin={this.props.islogAdmin}
                calculatePreviousDutyTime ={ this.calculatePreviousDutyTime.bind(this)}
                oncloseErrPop={() => this.oncloseErrPop.bind(this)}
                isResetWorkday={this.state.isResetWorkday}
                />
          );
      });
    }
      return activities;
   
    } else {
      return (
        <KeolisSpinner />
      );
    }
  }

  onCancelEmpComments() {
    this.props.onActErr(false, true); // para1: errpop, para2: acterr
    var workday = this.props.workday;
    this.props.onChangesInActivity(false);
  }

  onCancelActivityModal(workdayObj) {
    this.setState({ key: 1, isEdit: false },
      () => this.props.tabChange(this.state.key))
    this.props.resetWorkday(JSON.parse(JSON.stringify(this.props.defaultWorkday)));
    this.setState({isResetWorkday:true})
    this.renderCertifyModal();
    this.props.onChangesInActivity(false);
    setTimeout(
      function () {
        const scrollContainer = ReactDOM.findDOMNode(
          this.scrollContainer
        );
      });
    document.querySelectorAll('.showDetails input')[0].removeAttribute('disabled');
    document.querySelectorAll('.showDetails')[0].classList.remove("toggleDisabled");
  }

  renderEnDTab() {
    if (this.state.key == 3) {
      return (
        <EandDActivies />
      )
    }
  }

  checkActivityValid(activity) {
    let valid;
    if (activity.dty_act_name === '' || activity.dty_act_start_time === '' || activity.dty_act_end_time === '') {
      valid = false;
    } else {
      valid = true;
    }
    return valid;
  }
  validateHosLogCertify(){
    let message = '';
    let isValid = true;
    let dutyActivities = this.props.workday.duty_activity.filter((a) => !a.isDeleted);
    
    //duty type validation 
    let jobType = this.props.workday.job_type?this.props.workday.job_type.trim().replace('-','') : "";

    let isCoveredService = dutyActivities.filter(act => constants.HOS_COVERED_SERVICE.indexOf(act.dty_act_name.trim()) > -1).length > 0;
    if(!jobType){
      message = 'Please select duty type.';
      isValid = false;
    }


    if(isCoveredService.toString().trim()==='false' && (jobType.trim() =='1' || jobType.trim()=='2'))
    {
      message = 'Please select correct duty type.';
      isValid = false;
    }

    //start place and end place validation


      var regexpression = /^[a-zA-Z]*$/;
 
    if(dutyActivities && dutyActivities.length > 0){
      if (dutyActivities.filter((a) => a.dty_act_start_place === undefined || a.dty_act_start_place === '').length > 0) {
          message = 'Please enter start location for activity.';
        isValid = false;
      }
      else if (dutyActivities.filter((a) => !regexpression.test(a.dty_act_start_place)).length > 0)
      {
          message = 'The start location field must not contain numbers or symbols. Please enter a correct start location.';
          isValid = false;
      }


      if (dutyActivities.filter((a) => a.dty_act_end_place === undefined || a.dty_act_end_place === '').length > 0) {
        message = 'Please enter end location for activity';
        isValid = false;
      } else if (dutyActivities.filter((a) => !regexpression.test(a.dty_act_end_place)).length > 0) {
          message = 'The end location field must not contain numbers or symbols. Please enter a correct end location.';
          isValid = false;
      }


      if (dutyActivities.filter((a) => a.dty_act_end_date === undefined || a.dty_act_end_date === '').length > 0)
      {
        message = 'Please enter end Date for activity.';
        isValid = false;
      }

      
    }
    //deadhead validation
    let deadheadAct= this.props.workday.duty_activity.filter((d) => {
      let act_name_m = d.dty_act_name_updated?d.dty_act_name_updated : d.dty_act_name
      return act_name_m.trim().includes("Deadhead") && !d.isDeleted;
    });
    if(deadheadAct && deadheadAct.length == 2){
      if(deadheadAct[0].dty_act_name == deadheadAct[1].dty_act_name){
        message = 'Dead head activity names should not be identical';
        isValid = false;
      }
      else if (deadheadAct.filter((a) => a.dty_act_type === undefined || a.dty_act_type === '').length > 0) {
        message = 'Please enter type for dead head activity';
        isValid = false;
      }
      else if (deadheadAct.filter((a) =>a.dty_act_start_time == a.dty_act_end_time).length > 0) {
        message = 'Start time and end time should not be equal';
        isValid = false;
      }
      let deadheadStart = deadheadAct.find((act) => {
        let act_name_s = act.dty_act_name_updated?act.dty_act_name_updated : act.dty_act_name
        return act_name_s.includes("Deadhead to") && !act.isDeleted}
      );
      let deadheadEnd = deadheadAct.find((act) => {
        let act_name_e = act.dty_act_name_updated?act.dty_act_name_updated : act.dty_act_name
        return act_name_e.includes("Deadhead from") && !act.isDeleted
      });
      let endDate = moment(deadheadStart.dty_act_end_date ? deadheadStart.dty_act_end_date : this.props.workday.wdy_date,"MM/DD/YYYY").format("MM/DD/YYYY"); //end of dead head start
      let startDate = moment(deadheadEnd.dty_act_start_date ? deadheadEnd.dty_act_start_date : this.props.workday.wdy_date,"MM/DD/YYYY").format("MM/DD/YYYY"); //start of dead head end
      let endDateTime =  moment(endDate+' '+ (deadheadStart.dty_act_end_time_updated ? deadheadStart.dty_act_end_time_updated : deadheadStart.dty_act_end_time), 'MM/DD/YYYY hh:mm A');
      let startDateTime =  moment(startDate+' '+ (deadheadEnd.dty_act_start_time_updated ? deadheadEnd.dty_act_start_time_updated : deadheadEnd.dty_act_start_time), 'MM/DD/YYYY hh:mm A');
      if(!endDateTime.isBefore(startDateTime)){
        message = 'End time for dead head start should be less than start time for dead head end';
        isValid = false;
      }
      let toReverseActs = [...dutyActivities];
      let csStart = dutyActivities.find((act) => {
        let act_name_cs_s = act.dty_act_name_updated?act.dty_act_name_updated : act.dty_act_name;
        return act_name_cs_s.includes("Sign-on") && !act.isDeleted
      });
      let csEnd = toReverseActs.reverse().find((act) => {
        let act_name_cs_e = act.dty_act_name_updated?act.dty_act_name_updated : act.dty_act_name;
        return act_name_cs_e.includes("Sign-on") && !act.isDeleted
      });
      if(csStart && csEnd){
        //let countCS = dutyActivities.filter((act) => act.dty_act_name.includes("Sign-on") && !act.isDeleted);
        let cs1StartDate = moment(csStart.dty_act_start_date ? csStart.dty_act_start_date : this.props.workday.wdy_date,"MM/DD/YYYY").format("MM/DD/YYYY"); //start date of covered service 1
        let cs2EndDate = moment(csEnd.dty_act_end_date ? csEnd.dty_act_end_date : this.props.workday.wdy_date,"MM/DD/YYYY").format("MM/DD/YYYY"); //end date of covered service 2
        let cs1StartDateTime =  moment(cs1StartDate+' '+ (csStart.dty_act_start_time_updated ? csStart.dty_act_start_time_updated : csStart.dty_act_start_time), 'MM/DD/YYYY hh:mm A');
        let cs2EndDateTime =  moment(cs2EndDate+' '+ (csEnd.dty_act_end_time_updated ? csEnd.dty_act_end_time_updated : csEnd.dty_act_end_time), 'MM/DD/YYYY hh:mm A');
        if(!cs1StartDateTime.isSameOrAfter(endDateTime)){
          message = 'End time for dead head start should not be greater than start time of covered service start';
          isValid = false;
        }
        if(!startDateTime.isSameOrAfter(cs2EndDateTime)){
          message = 'Start time for dead head end should not be less than end time of covered service end';
          isValid = false;
        }
      }
      
    }
    else if(deadheadAct && deadheadAct.length == 1){
      if (deadheadAct.filter((a) => a.dty_act_type === undefined || a.dty_act_type === '').length > 0) {
        message = 'Please enter type for dead head activity';
        isValid = false;
      }
      else if (deadheadAct.filter((a) =>a.dty_act_start_time == a.dty_act_end_time).length > 0) {
        message = 'Start time and end time should not be equal';
        isValid = false;
      }
      let deadhead_act = deadheadAct[0];
      let dead_act_name = deadhead_act.dty_act_name_updated?deadhead_act.dty_act_name_updated : deadhead_act.dty_act_name;
      let act_endDate = moment(deadhead_act.dty_act_end_date ? deadhead_act.dty_act_end_date : this.props.workday.wdy_date,"MM/DD/YYYY").format("MM/DD/YYYY"); //end of dead head start
      let act_startDate = moment(deadhead_act.dty_act_start_date ? deadhead_act.dty_act_start_date : this.props.workday.wdy_date,"MM/DD/YYYY").format("MM/DD/YYYY"); //start of dead head end
      let act_endDateTime =  moment(act_endDate+' '+ (deadhead_act.dty_act_end_time_updated ? deadhead_act.dty_act_end_time_updated : deadhead_act.dty_act_end_time), 'MM/DD/YYYY hh:mm A');
      let act_startDateTime =  moment(act_startDate+' '+ (deadhead_act.dty_act_start_time_updated ? deadhead_act.dty_act_start_time_updated : deadhead_act.dty_act_start_time), 'MM/DD/YYYY hh:mm A');
      
      let toReverseActs_temp = [...dutyActivities];
      let act_csStart = dutyActivities.find((act) => {
        let act_name_c1 = act.dty_act_name_updated?act.dty_act_name_updated : act.dty_act_name;
        return act_name_c1.includes("Sign-on") && !act.isDeleted
      });
      let act_csEnd = toReverseActs_temp.reverse().find((act) => {
        let act_name_c2 = act.dty_act_name_updated?act.dty_act_name_updated : act.dty_act_name;
        return act_name_c2.includes("Sign-on") && !act.isDeleted
      });
      if(dead_act_name.includes("Deadhead to")){ //start
        if(act_csStart){
          let act_cs1StartDate = moment(act_csStart.dty_act_start_date ? act_csStart.dty_act_start_date : this.props.workday.wdy_date,"MM/DD/YYYY").format("MM/DD/YYYY"); //start date of covered service 1
          let act_cs1StartDateTime =  moment(act_cs1StartDate+' '+ (act_csStart.dty_act_start_time_updated ? act_csStart.dty_act_start_time_updated : act_csStart.dty_act_start_time), 'MM/DD/YYYY hh:mm A');
          if(!act_cs1StartDateTime.isSameOrAfter(act_endDateTime)){ //start: end time < cs start time
            message = 'End time for dead head start should not be greater than start time of covered service start';
            isValid = false;
          } 
        }
      }
      else if(dead_act_name.includes("Deadhead from")){ //end
        if(act_csEnd){
          let act_cs2EndDate = moment(act_csEnd.dty_act_end_date ? act_csEnd.dty_act_end_date : this.props.workday.wdy_date,"MM/DD/YYYY").format("MM/DD/YYYY"); //end date of covered service 2
          let act_cs2EndDateTime =  moment(act_cs2EndDate+' '+ (act_csEnd.dty_act_end_time_updated ? act_csEnd.dty_act_end_time_updated : act_csEnd.dty_act_end_time), 'MM/DD/YYYY hh:mm A');
          if(!act_startDateTime.isSameOrAfter(act_cs2EndDateTime)){
            message = 'Start time for dead head end should not be less than end time of covered service end';
            isValid = false;
          }
        }
      }
    }
    else if(deadheadAct && deadheadAct.length > 2){
      message = 'Only One pair of dead head activity(start/end) are allowed';
      isValid = false;
    }
    if(isValid)
    {
      return this.validateLimboActivity();
    }

    return { isValid,message };
  }


   // calculate previous time of duty
    
     calculatePreviousDutyTime(workday)
    {
    
        
        if(!Array.isArray(workday.duty_activity) 
          || workday.duty_activity.length == 0 
          || workday.prev_wdy_date == ''
          || workday.prev_wdy_spread == ''
          || workday.prev_wdy_time_end == ''
          || workday.prev_wdy_time_start == ''){
          return 0;
        }
        
          let dutyActivityArr = [...workday.duty_activity];
          
          dutyActivityArr = dutyActivityArr.filter(a=> a.isDeleted!=true).sort((a,b)=>{
            return new Date(a.dty_act_start_date+" "+((a.dty_act_start_time_updated && a.dty_act_start_time_updated.length > 0)?a.dty_act_start_time_updated:  a.dty_act_start_time))      
            - new Date(b.dty_act_start_date+" "+((b.dty_act_start_time_updated && b.dty_act_start_time_updated.length > 0)?b.dty_act_start_time_updated:  b.dty_act_start_time))
          }  
    
          );
    
          let startDateTime = (dutyActivityArr[0].dty_act_start_date)+" "+ ((dutyActivityArr[0].dty_act_start_time_updated && dutyActivityArr[0].dty_act_start_time_updated.length > 0)?dutyActivityArr[0].dty_act_start_time_updated:  dutyActivityArr[0].dty_act_start_time);
            startDateTime = moment(startDateTime);
    
        let prevWorkDateTime = moment(workday.prev_wdy_time_end);
        if(moment(workday.prev_wdy_time_end).isValid()){
          prevWorkDateTime = moment(workday.prev_wdy_time_end);
        } else {
          let endDate = workday.prev_wdy_date;
          let endTime = workday.prev_wdy_time_end;
          let endSplit = endTime.split(':');
          let hr = endSplit.length > 0 ? endSplit[0] : 0;
          let mins = endSplit.length > 1 ? endSplit[1] : 0;
          if(hr > 24){
              endDate = moment(workday.prev_wdy_date , "YYYY-MM-DD").add('day', 1);
              hr = hr - 24;
          } 
          endDate = moment(endDate).add('h', hr);
          endDate = moment(endDate).add('m', mins);
          prevWorkDateTime = endDate;
        }
        let diff = startDateTime.diff(prevWorkDateTime);
        if(Number.isNaN(diff)){
          return 0 ;
        }     
     
        
        return diff;
      }

      checkPreviousTimeLess8()
      {
        let minutes =0;
         if(this.props.workday.previous_Time_Off_Duty && this.props.workday.previous_Time_Off_Duty.length>0)
         {
          minutes= this.getTotalMinutesfromEditedPreviousTime(this.props.workday)
         }else
         {      
                let diff = this.calculatePreviousDutyTime( this.props.workday);
                minutes=  Math.floor(diff / 60000);
         }
     
      let hours = Math.floor(minutes / 60);    
      let isPreviousTimeless8 = false;
     
	  let islogUser = this.props.isLogUser;
      if(islogUser && hours < 8) isPreviousTimeless8= true;    
        
      return  isPreviousTimeless8;
      }

    getTotalMinutesfromEditedPreviousTime(workday)
    {    
    let duration = workday.previous_Time_Off_Duty?workday.previous_Time_Off_Duty:0;    
    let days = 0;
    let hours=0;
    let minutes=0;
    
    if(duration.toUpperCase().indexOf('D')>0) {days = duration.substring(0,duration.toUpperCase().indexOf('D')).trim();}
    if(duration.toUpperCase().indexOf('H')>0) {hours = duration.substring(duration.toUpperCase().indexOf('D')+1,duration.toUpperCase().indexOf('H')).trim();}
    if(duration.toUpperCase().indexOf('M')>0) {minutes = duration.substring(duration.toUpperCase().indexOf('H')+1,duration.toUpperCase().indexOf('M')).trim();}
   
    let totalMinutes = (hours * 60) + minutes ;
    return totalMinutes;
    }

   

    validateLimboActivity()
    {
      let message='';
      let isValid =true;
      var dutyActivities = this.props.workday.duty_activity;
      let limboActivities = dutyActivities.filter((d) => {
        let act_name = d.dty_act_name_updated?d.dty_act_name_updated : d.dty_act_name
        return act_name.trim().toLowerCase().includes("limbo") && !d.isDeleted;
      });
      let coveredService = dutyActivities.filter((act) =>{
      let actName = act.dty_act_name_updated?act.dty_act_name_updated.trim():act.dty_act_name.trim()
     return constants.HOS_COVERED_SERVICE.indexOf(actName)> -1 && !act.isDeleted ;
      })   
  
  
      if(Array.isArray(limboActivities) && limboActivities.length > 0){
       // check for more than one limbo 
       if(limboActivities.length>1)
       {
        message ="Only one Limbo activity allowed."
        isValid =false;
       }
       //check limbo is only activity
       if((limboActivities.length==1 && dutyActivities.length == 1) || ((limboActivities.length >0) && (coveredService.length ==0)))
       {
        message ="Limbo cannot be the only Activity.It should be after a covered service."
        isValid =false;
       }
       //limbo should have a covered service and come after a covered service    
        if ((limboActivities.length >0) && ((coveredService.length >0) ))
        {
          let act_start_date = coveredService[0].dty_act_start_date; 
          let act_limbo_date = limboActivities[0].dty_act_start_date; 
          let act_start_time = coveredService[0].dty_act_start_time_updated ? coveredService[0].dty_act_start_time_updated : coveredService[0].dty_act_start_time;
          let act_limbo_time = limboActivities[0].dty_act_start_time_updated ? limboActivities[0].dty_act_start_time_updated : limboActivities[0].dty_act_start_time;
          let start =  moment(act_start_date+' '+act_start_time, 'MM/DD/YYYY hh:mm A');
          let end =  moment(act_limbo_date+' '+act_limbo_time, 'MM/DD/YYYY hh:mm A');
          let diff = end.diff(start, 'minutes');
  
          if(diff < 0 || (coveredService[0].duty_activity_key > limboActivities[0].duty_activity_key))
          {
            message ="Limbo Activity should be after a covered service."
            isValid =false;
          }  
        
        }       
      }
      return { isValid,message };
      
    }
  


    onCertify(workdayId, changesInActivity, isSave) {
     

    let islogUser = this.props.isLogUser;
    let signOffTimeToday = this.props.workday.wdy_hos_11h59value;
    var certifyByAdmin = constants.certifyByAdmin;
    var role = this.props.authDetails.impersonateUserId > 0 ? 'Employee' : this.props.authDetails.role;
    var error = '', isValid = true;
    var duty_activity = this.props.workday.duty_activity;
    var len = 0, deleted = 0,
      dutyActivityIsPresent = this.props.workday.dutyActivityStatus == 'Y' ? true : false;
        var checkActivity
        localStorage.setItem("isHosCertifyClicked", isSave);
       
        if (this.checkPreviousTimeLess8()) {
          var activityModal = confirm("Previous time of duty is less than 8 hrs are you sure to continue !");
          if(!activityModal){return;}
        }

   
    for (var activity in duty_activity) {
      len++;
      checkActivity = this.checkActivityValid(duty_activity[activity]);
      if (duty_activity[activity].isDeleted) {
        deleted++;
      }
      if ((duty_activity[activity].isDeleted !== true) || duty_activity[activity].isNew === true) {
        if (duty_activity[activity].dty_act_name === '' && duty_activity[activity].dty_act_start_time === '' && duty_activity[activity].dty_act_end_time === '') {
          isValid = false;
          error = 'Please enter activity details for newly added activity';
        }
        else if (duty_activity[activity].dty_act_name === 'Select Activity') {
          isValid = false;
          error = 'Please select activity for newly added activity';
        }
        else if (duty_activity[activity].dty_act_start_time === '' && duty_activity[activity].dty_act_end_time === '') {
          error = 'Please enter start time and end time for newly added activity';
          isValid = false;
        }
        else if (duty_activity[activity].dty_act_start_time === '') {
          error = 'Please enter start time for newly added activity';
          isValid = false;
        } else if (duty_activity[activity].dty_act_end_time === '') {
          error = 'Please enter end time for newly added activity';
          isValid = false
        }
      }
      if (islogUser && duty_activity[activity].isDeleted !== true && (duty_activity[activity].acivity_alias_name == 'Interim Release' || duty_activity[activity].dty_act_name == 'Split break')){
        let act = duty_activity[activity];
        let act_start_date = act.dty_act_start_date ? act.dty_act_start_date : this.props.workday.wdy_date,
          act_end_date = act.dty_act_end_date ? act.dty_act_end_date : this.props.workday.wdy_date,
          act_start_time = act.dty_act_start_time_updated ? act.dty_act_start_time_updated : act.dty_act_start_time,
          act_end_time = act.dty_act_end_time_updated ? act.dty_act_end_time_updated : act.dty_act_end_time
        let a =  moment(act_start_date+' '+act_start_time, 'MM/DD/YYYY hh:mm A');
        let b =  moment(act_end_date+' '+act_end_time, 'MM/DD/YYYY hh:mm A');
        let diff = b.diff(a, 'minutes');
        if(diff < 240){
          error = 'Interim release cannot be less than 4 hours';
          isValid = false;
          this.props.onActErr(true, false, error);
          return;
        }
      }  
    }
    if (len === deleted) {
      var error = "At least 1 activity should be there to certify";
      this.props.onActErr(true, false, error); // para1: errpop, para2: acterr
      return;
    }
    if(islogUser){
      let validate = this.validateHosLogCertify();
      if(!validate.isValid){
        this.props.onActErr(true, false, validate.message); 
        return;
      }
      else
      {
        this.props.onActErr(false, false);
      }
    }
    var totalHOS = this.props.workday.wdy_working_time_hos_adjust && this.props.workday.wdy_working_time_hos_adjust != 'NULL'
                ? this.props.workday.wdy_working_time_hos_adjust
                : this.props.workday.wdy_working_time_hos;
    var isHOS_more_12hrs = totalHOS ? parseInt(totalHOS.substr(0,totalHOS.indexOf('h'))) >= 12 : false;     
        var counter = 0;

        if (isSave) {
          let inputParam={
            workdayId:this.props.workday.Id,
            workday:this.props.workday,
            cmts:"",
            changes:changesInActivity,
            role:this.props.authDetails.role,
            certifyByAdmin:certifyByAdmin,
            isHosSave:isSave,
            userId:this.props.authDetails.userId,
            historicalStartDate: this.props.historicalStartDate? this.props.historicalStartDate:"",
            historicalEndDate: this.props.historicalEndDate?this.props.historicalEndDate:""
          }  ;
          this.props.onCertifyHOSLog(inputParam);
           
            return;
        }

    if (this.props.activityErr) {
      for (var activity in duty_activity) {
        if (duty_activity[activity].isErr) {
          counter += 1;
        }
      }
      if (isValid === false) {
        this.props.onActErr(true, true, error); // para1: errpop, para2: acterr
      }
      else {
          if (signOffTimeToday || islogUser) {              
          this.props.onShowModal("Comments_Modal");
           }else if (!changesInActivity) {
              
            this.props.onCertify(workdayId, this.props.workday, "", changesInActivity, role, certifyByAdmin);
          } else if (changesInActivity && checkActivity) {
              
          this.props.onShowModal("Comments_Modal");
        } else {
          var error = 'Please enter activity details for newly added activity';
          this.props.onActErr(true, true, error);
        }
      }
    } else {   
        if (signOffTimeToday || islogUser) {                  
        this.props.onShowModal("Comments_Modal");
      }else if (!changesInActivity) {          
          this.props.onCertify(workdayId, this.props.workday, "", changesInActivity, role, certifyByAdmin);       
        } else if (changesInActivity && checkActivity) {
          
        this.props.onShowModal("Comments_Modal");
      } else {
        var error = 'Please enter activity details for newly added activity';
        this.props.onActErr(true, true, error);
      }
    }
  }
  showAlert() {
    var hideActivityModal = confirm("You will lose unsaved data.\nAre you sure you want to proceed?");
    if (hideActivityModal) {
      this.props.hideModal(false, "Certify_Modal");
    }
  }
  onHideModal() {
    this.setState({ isEdit: false })
    var changesInActivity = this.props.changesInActivity;
    if (changesInActivity) {
      this.showAlert();
    } else {
      this.props.hideModal(false, "Certify_Modal");
      this.props.toggleWorkday(false)
    }
    this.props.setDefaultWorkday({});
  }

  onEditAllActivity() {
    this.setState({ isEdit: true })
    let workday = this.props.workday, deleted = 0,
      error = 'At least 1 activity should be there to Edit';
    if (workday.duty_activity) {
      let dutyActivitycount = workday.duty_activity.length;
      for (var activity in workday.duty_activity) {
        if (workday.duty_activity[activity].isDeleted) {
          deleted++;
        }
      }
      if (dutyActivitycount === deleted) {
        this.props.onActErr(true, false, error); // para1: errpop, para2: acterr
      } else {
        this.props.editAllActivity();
        if(document.querySelectorAll('.showDetails input')[0]){
          document.querySelectorAll('.showDetails input')[0].setAttribute('disabled', 'disabled');
          document.querySelectorAll('.showDetails')[0].classList.add("toggleDisabled");
        }        
      }
    } else {
      this.props.onActErr(true, false, error); // para1: errpop, para2: acterr
    }
    this.setState({
      key:2
    })
    
    this.checkNonCoveredServiceActivities();
  }


  checkNonCoveredServiceActivities() {   
    let workday = this.props.workday;      
    let dutyActivities = workday.duty_activity.filter((a) => !a.isDeleted);
    let isCoveredService = dutyActivities.filter(act => constants.HOS_COVERED_SERVICE.indexOf(act.dty_act_name.trim()) > -1).length > 0;

    if (isCoveredService.toString().trim() === 'false' && (workday.job_type.trim() == '1' || workday.job_type.trim() == '2')) {        
        this.props.changeWorkdayActivity("job_type", constants.logTypes.DUTY_TYPE[2].name)       
        this.props.onChangesInActivity(false);
        
    }

  }


  showEditActivityButton() { 
    
    let workday = this.props.workday;
    
    if (workday) {
      
      if (workday.dutyActivityStatus == "N") {
        return false;
      }
      else if(this.props.isLogUser && this.props.workday.AllowAmendmentEdit == '0'){
        return false;
      }
      else if(this.props.islogAdmin){
        return false;
      }      
      else if (workday.duty_activity && (workday.duty_activity.length == 0 || workday.duty_activity[0].isNew)) {
        return false;
      }
    }
    return true;
  }
  checkPrevNonCertifiedWokrday() {
    let workdays = this.props.workdays, nonCertifiedWorkdays = [],
      wdy_date = this.props.workday.wdy_date, j;
    nonCertifiedWorkdays = workdays.filter(function (value, index) { // filtering uncertified workdays
      return ((value.wdy_certify_status == constants.UNCERTIFIED  && value.dutyActivityStatus == 'Y') || value.wdy_certify_status == constants.CLAIM);
    });
    var filtered = nonCertifiedWorkdays.filter(function (value) { // filtering workdays among filtered uncertified workdays
      return moment(wdy_date, constants.dateFormat).isAfter(moment(value.wdy_date, constants.dateFormat))
    });
    //for second start validation
    let first_start = false;
    if(this.props.workday.restbreak_no == '2'){
      let first_date = workdays.filter((a) => a.wdy_date == wdy_date && a.RestBreakNo == 1 && a.wdy_certify_status == constants.UNCERTIFIED);
      first_start = first_date.length > 0;
    };
    return filtered.length > 0 || first_start ? false : true;
  }
  toggleButton() {
    let toggleState = this.state.toggleState;
    this.setState({ toggleState: !toggleState }, () => this.props.toggleWorkday(toggleState));
  }
  chkWorkdayValidity() {
    let workday = this.props.workday, validWorkday, showErr;
    if (workday && Object.keys(workday).length > 0) {
      
        validWorkday = this.checkPrevNonCertifiedWokrday();
        showErr = true;

    }
    return {
      'validWorkday': validWorkday,
      'showErr': showErr
    }
  }
  handleTabChange(key) {
    this.setState({ key: key },
      () => this.props.tabChange(this.state.key))
  }

  getWorkdayDate(){
    if(localStorage.getItem('route') == constants.FRA_REPORT && Array.isArray(this.props.fraworkdays) && !this.props.isLoading){
      return this.props.fraworkdays && this.props.fraworkdays.length >0 ?this.props.fraworkdays[0].wdy_date:"";
    }
    else{
      return this.props.workday && this.props.workday.wdy_date?this.props.workday.wdy_date:"";
    }
  }
  render() {

 

    var activityErrMessage = '';
    if (this.props.activityErrPopup) {
      activityErrMessage = this.props.activityErrMessage
    }
    let role = this.props.authDetails.role, validWorkday = false, showErr = false;
    const isMenumappingConf = role == constants.roles.ADMIN_ROLE || 
                (this.props.authDetails.activeMenus && Array.isArray(this.props.authDetails.activeMenus) && this.props.authDetails.activeMenus.length > 0) ;
    validWorkday = this.chkWorkdayValidity();
    let today = moment(this.props.authDetails.server_time,"YYYY-MM-DD HH:mm:ss").format("MM/DD/YYYY");
    let viewMode = this.props.workday ?
                    this.props.workday.wdy_date == today ? 
                      this.props.authDetails.isOnDutyLoggedin && this.props.authDetails.isOnDutyLoggedinForToday 
                      : this.props.authDetails.isOnDutyLoggedin : false;  
            

   return (
      <ActivityModalComp toggleButton={() => this.toggleButton.bind(this)} toggleState={this.state.toggleState} role={role} showErr={validWorkday.showErr} workday={this.props.workday} showModal={this.props.showModal} onHideModal={() => this.onHideModal.bind(this)}
        modalName={this.props.modalName} modalTitle={isMenumappingConf ? constants.MODAL_TITLE : constants.MODAL_TITLE_OLD} latestRecords={this.props.latestRecords}
        activityErrPopup={this.props.activityErrPopup} showEditActivityButton={this.showEditActivityButton()} defaultWorkday={this.props.defaultWorkday}
        onEditAllActivity={() => this.onEditAllActivity.bind(this)} oncloseErrPop={() => this.oncloseErrPop.bind(this)}
        activityErrMessage={activityErrMessage} renderCertifyModal={this.renderCertifyModal.bind(this)}
        changesInActivity={this.props.changesInActivity} validWorkday={this.props.isPayDetail ? true : validWorkday.validWorkday }
        onCancelActivityModal={() => this.onCancelActivityModal(this.props.workday)}
        onCertify={(isSave) => this.onCertify(this.props.workday.Id, this.props.changesInActivity,isSave)}
        handleTabChange={() => this.handleTabChange.bind(this)}
        eventKey={this.state.key} isEdit={this.state.isEdit} renderEnDTab={() => this.renderEnDTab()}
        isLoading={this.props.isLoading} renderErrorMessage={() => this.showErrorMessage()}
        getWorkdayDate={this.getWorkdayDate()}
        activityErr={this.props.activityErr} certifyError={this.props.certifyError} isLogUser = {this.props.isLogUser} islogAdmin = {this.props.islogAdmin} authDetails = {this.props.authDetails} 
        isViewMode = {isMenumappingConf ? !viewMode : false}
        
        checkPreviousTimeLess8 ={this.checkPreviousTimeLess8.bind(this)}
        />
    );
  }

}

function mapStateToProps(state) {

  return {
    showModal: state.modals.showModal,
    isLoading: state.workday.isLoading,
    modalName: state.modals.modalName,
    changesInActivity: state.modals.changesInActivity,
    workday: state.workday.workday,
    fraworkdays: state.FRA.fraworkdays,
    defaultWorkday: state.workday.defaultWorkday,
    workdays: state.workdays.workdays,
    activityErrPopup: state.modals.activityErrPopup,
    activityErr: state.modals.activityErr,
    certifyError: state.modals.certifyError,
    latestRecords: state.modals.latestRecords,
    activityErrMessage: state.modals.activityErrMessage,
    authDetails: state.authState,
    activityModalToggleState: state.activityModalToggleState,
    activityModalkey: state.activityModalkey,
    activityModalIsEdit: state.activityModalIsEdit
  };
}

function matchDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      editAllActivity: editAllActivityAction,
      hideModal: hideModalAction,
      onChangesInActivity: changesInActivityAction,
      onShowModal: showModalAction,
      getWorkday: getWorkdayAction,
      onCertify: onCertifyAction,
      onCertifyHOSLog : onCertifyHOSLogAction,
      onActErr: actErrorAction,
      onSubmitWorkday: submitWorkdayAction,
      resetWorkday: resetWorkdayAction,
      setDefaultWorkday: setDefaultWorkdayAction,
      toggleWorkday: toggleWorkdayAction,
      tabChange: tabChangeAction,
      changeWorkdayActivity:changeWorkdayActivityLogs

    }, dispatch
  );
}

export default connect(mapStateToProps, matchDispatchToProps)(ActivityModal);
